import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, Box, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField } from '@mui/material';
import imgFondo from '../../assets/pino.png';
import { exportComponentAsPNG } from "react-component-export-image";
import QRCode from 'qrcode.react';
import { ButtonStyleAzul, ButtonStyleWhite } from "../../styles/Styles";
import { Send } from "@mui/icons-material";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import { postCancelarQr, postConsultarPagos, postDetailsQr } from "../../api/Api";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const QrComponents = ({ handleCancelarQr, open, dataQr, dataUser, monto, qrHub, setSeverity, setMensaje, setOpenAlert }) => {
    const QRRef = useRef();
    const intervalQr = useRef(null);
    const timerRef = useRef(null);

    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);



    useEffect(() => {
        let intervalApi = 3000;
        let timerCloseApi = 300000;//tiempo de 5 minutos


        intervalQr.current = setInterval(() => {

            console.log('consultando qr');
            handleDetailsQr();

        }, intervalApi);

        //se cancela en 5 minutos, si no se paga el qr || se cancela si el usuario cierra el modal
        timerRef.current = setTimeout(() => {
            console.log('termino los 1 minuto')
            handleCancelarQrAction();
            setOpenAlert(true);
            setSeverity('warning');
            setMensaje('El tiempo para pagar ha expirado');
        }, timerCloseApi);

        return () => {
            clearInterval(intervalQr.current);
            clearTimeout(timerRef.current);
        }

    }, []);




    const downloadPng = async () => {
        await exportComponentAsPNG(QRRef, { fileName: 'qr_transferencia' });
    };

    const handleDetailsQr = () => {
        let data = {};
        data.idQr = dataQr.idQr;
        data.codComercio = stateToken.codeComercio;
        data.qrHub = qrHub;

        postDetailsQr(data)
            .then((response) => {
                //valido que la respuesta header.codRespuesta === 0
                if(response.header.codRespuesta === '0'){
                    console.log("response-details", response);
                    //si el array de pagis esta vacio, quiere decir que no se ha pagado, si no esta vacio, quiere decir que se ha pagado
                    if(response.data.pagos.length > 0){
                        console.log("pagado");
                        clearInterval(intervalQr.current);
                        clearTimeout(timerRef.current);

                        if (qrHub === false) {
                            const fechaHoy = dayjs().format('DD-MM-YYYY');
                            const bodyConsultar = {
                                fechaInicio: fechaHoy,
                                fechaFin: fechaHoy,
                                codComercio: '',
                                idQr: response.data.pagos[0].idQr,
                                idPagoQr: response.data.pagos[0].idPagoQr,
                                importe: '',
                                docUsuario: '',
                                qrHub: false,
                                filtro: { posInicial: 0, cantidad: 1 }
                            };

                            postConsultarPagos(bodyConsultar)
                                .then((consultaResponse) => {
                                    let idTxDestinatario = '';
                                    if (consultaResponse.header.codRespuesta === '0' && consultaResponse.lista && consultaResponse.lista.length > 0) {
                                        idTxDestinatario = consultaResponse.lista[0].idTxDestinatario;
                                    }
                                    handleCancelarQr();
                                    history('/home/payment/confirmacion', { state: { ...response, idTxDestinatario }, replace: true });
                                })
                                .catch((err) => {
                                    console.warn("error-consultar-pago", err);
                                    handleCancelarQr();
                                    history('/home/payment/confirmacion', { state: response, replace: true });
                                });
                        } else {
                            const idOperacion = response.data.pagos[0]?.idOperacion || '';
                            handleCancelarQr();
                            history('/home/payment/confirmacion', { state: { ...response, idOperacion, _esSip: true }, replace: true });
                        }
                    }

                }else{
                    console.warn("error-details-qr", response);
                    clearInterval(intervalQr.current);
                    clearTimeout(timerRef.current);
                    handleCancelarQr();
                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(response.header.txtRespuesta);
                }
            })
    }


    const handleCancelarQrAction = () => {
        console.log("handleCancelarQrAction");
        let data = {};
        data.idQr = dataQr.idQr;

        clearInterval(intervalQr.current);
        clearTimeout(timerRef.current);
        handleCancelarQr();

        postCancelarQr(data)
            .then((response) => {
                if (response.codRespuesta !== '0') {
                    console.warn("error-cancelar-qr", response);
                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(response.txtRespuesta);
                }
            })
            .catch((error) => {
                console.warn("error-cancelar-qr", error);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje('No se pudo cancelar el QR');
            });
    }


    const handleCaptureMobile = () => {
        html2canvas(QRRef.current)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                // console.log("imgData", imgData);
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'share', data: imgData, fileName: 'qr_transferencia' }));
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    //usar share para compartir el qr, no se si funciona en todos los navegadores
    const handleShare = async () => {

        //pasar el qr a base64=> solo pasa el qr, no envia el monto ni el nombre del usuario
        // const canvas = QRRef.current.querySelector('canvas');
        // const dataURL = canvas.toDataURL();


        //enviar el mensaje a la webView de react native, para que se pueda compartir
        if (window.ReactNativeWebView) {//se valida si es una app de react native
            handleCaptureMobile();
        } else {
            console.log("es el navegador web");
            downloadPng();
        }

    }


    const handleRedirectConfirmacion = () => {
        // history('/home/payment/confirmacion', { state: body, replace: true });
    }



    return (
        <Dialog
            // onClose={handleCancelarQrAction} 
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            {/* <DialogTitle id="simple-dialog-title">QR de Transferencia</DialogTitle> */}

            <Box
                p={1}
                pt={0}
                textAlign="center"
            >
                <Box
                    ref={QRRef}
                >
                    <Box textAlign="center">
                        <Typography
                            variant="h6"
                            color="textPrimary"
                            style={{ padding: '0px 0px 10px' }}
                        >
                            {dataUser}
                        </Typography>
                    </Box>

                    {monto !== '0' && (
                        <Box textAlign="center">
                            <Typography
                                variant="h6"
                                color="textPrimary"
                                style={{ padding: '0px 0px 10px' }}
                            >
                                {`${Number(monto).toLocaleString('es-PY', { minimumFractionDigits: 0 })} Gs.`}
                            </Typography>
                        </Box>
                    )}

                    <Box textAlign="center">
                        <Typography
                            variant="h5"
                            color="textPrimary"
                            style={{ padding: '10px 0px', fontWeight: 'bold' }}
                        >
                            Escanea y pagá
                        </Typography>
                    </Box>

                    <img
                        src={dataQr.image}
                        alt="qr"
                        style={{ width: '100%', height: '100%' }}
                    />
                </Box>

                <Box
                    mt={1}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '0px 10px'
                    }}
                >
                    <div style={{ width: '48%' }}>
                        <ButtonStyleWhite
                            variant="contained"
                            style={{
                                width: '100%',
                                height: '50px',
                                borderRadius: '10px',
                                color: '#333',
                                fontSize: '12px'
                            }}
                            // onClick={handleCancelarQr}
                            onClick={handleCancelarQrAction}
                        >
                            Cancelar
                        </ButtonStyleWhite>
                    </div>

                    <div style={{ width: '48%' }}>
                        <ButtonStyleAzul
                            variant="contained"
                            style={{
                                width: '100%',
                                height: '50px',
                                borderRadius: '10px',
                                fontSize: '12px'
                            }}
                            startIcon={<Send />}
                            // onClick={downloadPng}
                            onClick={handleShare}
                        >
                            Compartir
                        </ButtonStyleAzul>
                    </div>
                </Box>
            </Box>
        </Dialog>
    )
}

export default QrComponents;